import React from 'react'
import {
  CWidgetDropdown,
  CRow,
  CCol,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import ChartLineSimple from '../charts/ChartLineSimple'
import ChartBarSimple from '../charts/ChartBarSimple'
import history from '../../history';
import ReactGA from 'react-ga';

const WidgetsDropdown = () => {

  const viewAllCanadianElections = () => {
    history.push('/political/canada/federal/election/');
    ReactGA.event({ category: "WidgetPanel", action: "click", label: 'all elections' });
  }

  const goLatest = () => {
    history.push('/political/canada/federal/election/2021');
    ReactGA.event({ category: "WidgetPanel", action: "click", label: 'current election' });
  }

  const electionscanada = () => {
    window.open('https://elections.ca/home.aspx');
    ReactGA.event({ category: "WidgetPanel", action: "click", label: 'elections canada' });
  }

  const howtovote = () => {
    window.open('https://www.elections.ca/content2.aspx?section=vote&document=index&lang=e');
    ReactGA.event({ category: "WidgetPanel", action: "click", label: 'how to vote' });
  }

  const statcan = () => {
    window.open('https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/index-eng.cfm');
    ReactGA.event({ category: "WidgetPanel", action: "click", label: 'statscan' });
  }
  // render
  return (
    <CRow>
      <CCol sm="6" lg="3">
        <CWidgetDropdown
          color="gradient-primary"
          onClick={() => viewAllCanadianElections()}
          style={{cursor:'pointer'}}
          header="8"
          text="Federal Elections"
          footerSlot={
            <ChartLineSimple
              pointed
              className="c-chart-wrapper mt-3 mx-3"
              style={{height: '70px'}}
              dataPoints={[]}
              pointHoverBackgroundColor="primary"
              label="Members"
              labels="months"
            />
          }
        >
          <CDropdown>
            <CDropdownToggle caret={false} color="transparent">
              <CIcon name="cil-x-circle"/>
            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end">
              <CDropdownItem onClick={() => viewAllCanadianElections()}>View All</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CWidgetDropdown>
      </CCol>

      <CCol sm="6" lg="3">
        <CWidgetDropdown
          color="gradient-info"
          style={{cursor:'pointer'}}
          onClick={() => goLatest()}
          header="338"
          text="Current Ridings"
          footerSlot={
           <ChartLineSimple
              pointed
              className="mt-3 mx-3"
              style={{height: '70px'}}
              dataPoints={[]}
              pointHoverBackgroundColor="info"
              options={{ elements: { line: { tension: 0.00001 }}}}
              label="Members"
              labels="months" 
          /> 
          }
        >
          <CDropdown>
            <CDropdownToggle caret={false} color="transparent">
              <CIcon name="cil-location-pin"/>
            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end">
              <CDropdownItem onClick={() => goLatest()}>View 2019 Map</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CWidgetDropdown>
      </CCol>

      <CCol sm="6" lg="3">
        <CWidgetDropdown
          color="gradient-warning"
          header="TBD"
          text="Next Election Date"
          footerSlot={
            <ChartLineSimple
              className="mt-3"
              style={{height: '70px'}}
              backgroundColor="rgba(255,255,255,.2)"
              dataPoints={[]}
              options={{ elements: { line: { borderWidth: 2.5 }}}}
              pointHoverBackgroundColor="warning"
              label="Members"
              labels="months"
            />
          }
        >
          <CDropdown>
            <CDropdownToggle color="transparent">
              <CIcon name="cil-pencil"/>
            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end">
              <CDropdownItem onClick={() => electionscanada()}>Elections Canada</CDropdownItem>
              <CDropdownItem onClick={() => howtovote()}>How to Vote</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CWidgetDropdown>
      </CCol>

      <CCol sm="6" lg="3">
        <CWidgetDropdown
          color="gradient-danger"
          header="2016"
          text="Last Census Integrated"
          footerSlot={
            <ChartBarSimple
              className="mt-3 mx-3"
              style={{height: '70px'}}
              dataPoints={[]}
              backgroundColor="rgb(250, 152, 152)"
              label="Members"
              labels="months"
            />
          }
        >
          <CDropdown>
            <CDropdownToggle caret className="text-white" color="transparent">
              <CIcon name="cil-people"/>
            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end">
              <CDropdownItem onClick={() => statcan()}>Statistics Canada</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CWidgetDropdown>
      </CCol>
    </CRow>
  )
}

export default WidgetsDropdown
